import { render, staticRenderFns } from "./RetailAdManager.vue?vue&type=template&id=4beda471"
import script from "./RetailAdManager.vue?vue&type=script&lang=js"
export * from "./RetailAdManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports